module.exports = __webpack_public_path__ + "static/Foodservice-hero-e839d7ef678574cc524ff948a025bb2a.png";